/**
 * Copyright 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const deletePermission = `mutation DeleteRbacRoleBinding($customer_id: String!, $id: String!) {
    deleteRbacRoleBinding(customer_id: $customer_id, id: $id)
  }
`;
